module.exports = __webpack_public_path__ + "static/media/download_soldiers_small.6f469d42.png";